import { cn } from '@/lib/utils'
import LinkWithTransition from '@/v2/components/helpers/link-with-transition'
import ResponsiveImage from '@/v2/components/helpers/responsive-image'
import { Button } from '@/v2/components/ui/button'
import SectionWrapper from '@/v2/components/wrappers/section-wrapper'
import { staggerContainer, zoomIn } from '@/v2/constants/motion'
import { CardType } from '@/v2/types/cards'
import { domAnimation, LazyMotion, m } from 'framer-motion'
import React from 'react'

interface InfoBannerSectionProps extends React.HTMLAttributes<HTMLDivElement> {
  card: CardType
  ctaButton: { href: string; text: string }
}

const InfoBannerSection: React.FC<InfoBannerSectionProps> = props => {
  const { card, ctaButton, className, ...rest } = props

  return (
    <LazyMotion features={domAnimation}>
      <m.section
        variants={staggerContainer(1, 0)}
        initial='hidden'
        whileInView='show'
        viewport={{ once: true, amount: 0.25 }}
        title={card.title}
        className='text-center landing-pages-wr section-container section-spacing '
      >
        <SectionWrapper {...rest}>
          <m.article
            className={cn(
              'flex items-center lg-mn:gap-[70px] gap-[20px] bg-secondary-first rounded-lg p-[20px] lg-mn:px-[30px] lg-mn:flex-row flex-col min-h-[334px]',
              className
            )}
            variants={zoomIn(0, 1)}
          >
            <ResponsiveImage src={card.image.src} alt={card.image.alt} className='max-w-[410px] max-h-[224px]' />

            <div className='lg-mn:text-left [&>h2]:text-secondary xl:pr-[130px] [&>h2]:font-[700] lg-mn:[&>h2]:text-[36px] [&>h2]:text-[24px] [&>h2]:leading-[30px] md-mn:[&>h2]:leading-[56px]'>
              <h2>{card.title}</h2>
              <p className='text-paragraph mt-[12px] leading-[24px]'>{card.description}</p>
              <LinkWithTransition href={ctaButton.href} className='self-center lg-mn:self-start'>
                <Button variant='call_to_action' className='transition-all animate-bounce mt-6 w-[248px]'>
                  {ctaButton.text}
                </Button>
              </LinkWithTransition>
            </div>
          </m.article>
        </SectionWrapper>
      </m.section>
    </LazyMotion>
  )
}
export default InfoBannerSection
